import React, { useState, useEffect } from 'react';

import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';
import SatCheckBox from '@components/common/satUI/SatCheckBox';

const SimpleProductReasonCheckPopup = props => {
  const {
    visible,
    setVisible,
    verifyData: { applyInformationResult },
    rePublishInfo: { rePublishYn },
    siProductChkVal,
    onOk,
  } = props;

  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [siProdhkVal, setSiProdhkVal] = useState(siProductChkVal);

  useEffect(() => {
    if (!visible && isChecked) setIsChecked(false);
    if (!visible && isChecked2) setIsChecked2(false);
    if (rePublishYn === 'Y') {
      if (siProductChkVal === '3') {
        setIsChecked(true);
        setIsChecked2(true);
      } else if (siProductChkVal === '2') {
        setIsChecked2(true);
      } else if (siProductChkVal === '1') {
        setIsChecked(true);
      }
    }
  }, [visible]);

  useEffect(() => {
    if (isChecked && isChecked2) {
      setSiProdhkVal('3');
    } else if (isChecked2) {
      setSiProdhkVal('2');
    } else if (isChecked) {
      setSiProdhkVal('1');
    } else {
      setSiProdhkVal('0');
    }
  }, [isChecked, isChecked2]);

  const saveSiprodChkVal = () => {
    applyInformationResult.applAdtnItmDtlList = [
      ...applyInformationResult.applAdtnItmDtlList,
      {
        applAdtnInfoTpCd: '0801',
        applAdtnSno: 1,
        applAdtnDataTyTpCd: '2',
        applAdtnInfoDataVal: siProdhkVal,
        applNo: null,
      },
    ];
    onOk(siProdhkVal);
  };

  return (
    <SatModal visible={visible} setVisible={setVisible} wide>
      <div className="cont">
        <div className="info-box mgt-20 mgb-0">
          <p className="c-red" style={{ fontSize: '1.5rem' }}>
            ※ 간편심사 상품의 경우 아래 질의에 대해 필수 체크하여 주시고, 해당 사항이 없는 경우 간편심사 상품 청약이 제한됩니다.
          </p>
          <p style={{ fontSize: '1.5rem' }}>
            간편심사 상품은 유병력자 또는 연령제한 등 일반심사 상품에 가입하기 어려운 피보험자를 대상으로 하는 상품으로,  본 상품의 취지에 적합한 대상이신지 확인하기 위해 아래 질문에 대한 답변을 체크해 주시기 바랍니다.
          </p>
          <p style={{ fontSize: '1.5rem', marginTop: '2rem' }}>
            피보험자분이 간편심사 상품에 가입하시는 사유는 무엇입니까?
          </p>
          <SatCheckBox
            value={[isChecked]}
            disabled={rePublishYn === 'Y'}
            options={[
              { label: '유병력자로 일반심사 상품 가입이 불가함', value: '1' },
            ]}
            customStyleClass={'mgt-5'}
            onChange={checked => setIsChecked(checked)}
          />
          <SatCheckBox
            value={[isChecked2]}
            disabled={rePublishYn === 'Y'}
            options={[
              { label: '일반심사 상품 청약시 검진대상에 해당됨', value: '2' },
            ]}
            customStyleClass={'mgt-5'}
            onChange={checked => setIsChecked2(checked)}
          />
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          label={'확인'}
          styleClass={'btn-s blue btn-wide'}
          disabled={!isChecked && !isChecked2}
          onClick={saveSiprodChkVal}
        />
      </div>
    </SatModal>
  );
};

export default React.memo(SimpleProductReasonCheckPopup);
